import { IQueryOptions, IExecutionOptions } from '../models/query';
import { ConditionalHelper } from '../helpers/ConditionalHelper';
import { TranslationHelper } from '../helpers/TranslationHelper';
import { IQueryOptionsValueCollectionBase } from '../models/query/options/IQueryOptionsValueCollectionBase';
import { BaseCollectionQuery } from './BaseCollectionQuery';

export abstract class BaseValueCollectionQuery<TChildOptions extends IQueryOptionsValueCollectionBase> extends BaseCollectionQuery<TChildOptions> {
	constructor(queryOptions: IQueryOptions, translationHelper?: TranslationHelper) {
		super(queryOptions, translationHelper);
	}
	getRawValueOrRootKey(executionOptions: IExecutionOptions) {
		const { rootKey } = this.queryOptions;
		if (rootKey) {
			const collectionItem = this.getCollectionItem(executionOptions);
			return collectionItem[rootKey];
		}
		return this.getRawValueFromSubCollection(executionOptions);
	}
	getRawValueFromSubCollection(executionOptions: IExecutionOptions) {
		const conditionalHelper = new ConditionalHelper({ conditions: [] }, this.translationHelper);
		const {
			key,
			collectionItemValueConditional,
		} = this.options;
		const entity = this.getEntity(executionOptions);
		if (entity) {
			const collectionItem = this.getCollectionItem(executionOptions);
			const { values = [] } = collectionItem || {};
			const matchingValues = values.filter(value => !collectionItemValueConditional || conditionalHelper.matchesWithOptions({
				executionOptions,
				instance: value,
				conditional: collectionItemValueConditional,
			}));
			if (matchingValues && matchingValues.length > 0) {
				const item = this.getItem(executionOptions, matchingValues);
				if (item) {
					if (key) {
						return item[key];
					}
					return item;
				}
			}
		}
		return;
	}
	getCollectionItem<T = any>(executionOptions: IExecutionOptions): undefined | T {
		const conditionalHelper = new ConditionalHelper({ conditions: [] }, this.translationHelper);
		const {
			code,
			collectionItemConditional = { conditions: [] },
		} = this.options;
		if (code && !collectionItemConditional.conditions.find(condition => condition.field === 'code')) {
			collectionItemConditional.conditions.push({
				field: 'code',
				operator: '=',
				value: code,
			});
		}
		const collectionItem = this.getSubCollection(executionOptions)
			.find(item => conditionalHelper.matchesWithOptions({
				executionOptions,
				instance: item,
				conditional: collectionItemConditional,
			}));
		return collectionItem;
	}
}